import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import Stepper from '../../components/Stepper/Stepper';
import StepTitle from '../../components/StepTitle/StepTitle';
import Selector from '../../components/Selector/Selector';
import NextButton from '../../components/NextButton/NextButton';

class StepTwo extends Component {
  componentDidMount() {
    if(process.env.PUBLIC_URL) {
      const pathname = `${process.env.PUBLIC_URL}/step2`;
      ReactGA.pageview(pathname);
    }
  }
  render() {
    const stepNumber = 2;
    const title = 'サービスのご利用状況を選択してください。';
    //const question = 'あさがおテレビで、ご利用中のサービスを教えてください。';
    const options = [ '利用している', '利用していない' ];

    const {
      postalInfo,
      currentService,
      dispatchSetCurrentService,
    } = this.props;

    if (!postalInfo) {
      this.props.history.push({ pathname: `${process.env.PUBLIC_URL}/step1` })
    }

    const handleNext = () => {
      this.props.history.push(
        {
         pathname: `${process.env.PUBLIC_URL}/step3`,
        }
      )
    }

    const validateForm = () => {
      return !currentService.length;
    }

    const onClick = selectedIndex => {
      dispatchSetCurrentService(selectedIndex);
    }

    return (
      <div id="container" className="container" >
        <Stepper activeNumber={stepNumber} />
        <StepTitle
          stepNumber={stepNumber}
          title={title}
        />
        <Selector
          options={options}
          must
          onClick={onClick}
          selected={currentService}
          underDot
        />
        <NextButton
          onClick={handleNext}
          disable={validateForm()}
        />
      </div>
    );
  }
};

export default withRouter(StepTwo);
